module.exports = __webpack_public_path__ + "static/media/Zeiser-Light.e7850aa6.webp";